import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/02/10/principle/filtered-noise-e.wav`,
      text: "play sound",
      shape: "round",
      icon: "cis-volume-high",
    },
  },
];

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/10/principle/chart-1-5.svg`,
        },
      },
      styles: {
        width: "75%",
      },
    },
  },
];
